import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { CircleDollarSign } from "lucide-react";
import api, { formatApiError } from "../lib/api";
import { PageHeader, DataTable, fmt } from "../components/bits";
import { Button } from "../components/ui/button";

export default function CashClosing() {
  const [closings, setClosings] = useState([]);

  const load = useCallback(() => {
    api.get("/cash-closings").then((r) => setClosings(r.data)).catch((e) => toast.error(formatApiError(e)));
  }, []);
  useEffect(() => { load(); }, [load]);

  const closeToday = async () => {
    try {
      const r = await api.post("/cash-closings", {});
      toast.success(`${r.data.number} generado — balance ${fmt(r.data.balance)}`);
      load();
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  const columns = [
    { key: "number", label: "Cierre", render: (c) => <span className="font-mono text-xs font-semibold">{c.number}</span> },
    { key: "date", label: "Fecha" },
    { key: "total_income", label: "Ingresos", render: (c) => <span className="text-emerald-700 font-medium">{fmt(c.total_income)}</span> },
    { key: "total_expenses", label: "Gastos", render: (c) => <span className="text-rose-700 font-medium">{fmt(c.total_expenses)}</span> },
    { key: "balance", label: "Balance", render: (c) => <span className="font-bold">{fmt(c.balance)}</span> },
    {
      key: "by_method", label: "Por método",
      render: (c) => (
        <span className="text-xs text-slate-500">
          {Object.entries(c.by_method || {}).map(([m, v]) => `${m}: ${fmt(v)}`).join(" · ") || "—"}
        </span>
      ),
    },
    { key: "closed_by", label: "Responsable" },
  ];

  return (
    <div data-testid="cash-closing-page">
      <PageHeader title="Cierre de Caja" subtitle="Balance diario: ingresos − gastos">
        <Button data-testid="close-cash-button" className="bg-blue-800 hover:bg-blue-700" onClick={closeToday}>
          <CircleDollarSign className="w-4 h-4 mr-1" /> Cerrar caja de hoy
        </Button>
      </PageHeader>
      <DataTable columns={columns} rows={closings} testid="closings-table" />
    </div>
  );
}
